import { combineReducers } from '@reduxjs/toolkit';
import getSlaContentReducer from './get-sla-content';
import updateSlaContentReducer from './update-sla-content';

const slaContentReducer = combineReducers({
  getSlaContent: getSlaContentReducer,
  updateSlaContent: updateSlaContentReducer
});

export default slaContentReducer;